import { Visibility, VisibilityOff } from "@mui/icons-material"
import { IconButton, InputAdornment, TextField } from "@mui/material"
import { useState } from "react"

const PasswordInput = ({
  ...props
}) => {

  const [show_password, set_show_password] = useState(false);

  return(
    <TextField

      type={show_password ? 'text' : 'password'}

      { ...props }

      slotProps={{
        input : {
          endAdornment : (
            <InputAdornment
              position="end"
            >
              <IconButton
                tabIndex={-1}
                size="small"
                onClick={() => set_show_password(!show_password)}
              >
                {
                  show_password ? <Visibility /> : <VisibilityOff />
                }
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  )
}

export default PasswordInput;